import DataroomsTable from './DataroomsTable';

export default DataroomsTable;
